import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

import { PaginaPrincipalComponent } from './pagina-principal.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { Path } from 'src/app/util/path';
import { ChatComponent } from 'src/app/shared/components/chat/chat.component';
import { FormsModule } from '@angular/forms';


const routes: Routes = [

    {
        path: '',
        component: PaginaPrincipalComponent
    },
    {
        path: Path.CANAIS_ATENDIMENTO.caminho,
        loadChildren: () => import('../canais-atendimento/canais-atendimento.module').then(m => m.CanaisAtendimentoModule)
    },
    {
        path: Path.EXPURGOS_INFLACIONARIOS.caminho,
        loadChildren: () => import('./../expurgos-inflacionarios/expurgos-inflacionarios.module').then(m => m.ExpurgosInflacionariosModule)
    },
    {
        path: Path.ALVARAS_JUDICIAIS.caminho,
        loadChildren: () => import('./../alvaras-judiciais/alvaras-judiciais.module').then(m => m.AlvarasJudiciaisModule)
    },
    {
        path: Path.BUSCA_PROCESSUAL.caminho,
        loadChildren: () => import('./busca-processual/busca-processual.module').then(m => m.BuscaProcessualModule)
    },
    {
        path: Path.TRANSPARENCIA.caminho,
        loadChildren: () => import('./../transparencia/transparencia.module').then(m => m.TransparenciaModule)
    },
    {
        path: Path.IMPRENSA.caminho + '/' + Path.NOTICIAS,
        loadChildren: () => import('./../imprensa/noticias/noticias.module').then(m => m.NoticiasModule)
    },
    {
        path: Path.JUIZADOS_ESPECIAIS.caminho,
        loadChildren: () => import('./../juizados-especiais/juizados-especiais.module').then(m => m.JuizadosEspeciaisModule)
    },
    {
        path: Path.PJE.caminho,
        loadChildren: () => import('./../pje/pje.module').then(m => m.PjeModule)
    },
    {
        path: Path.JURISDICAO.caminho,
        loadChildren: () => import('./../jurisdicao/jurisdicao.module').then(m => m.JurisdicaoModule)
    },
    {
        path: Path.COOPERACAO.caminho,
        loadChildren: () => import('./../cooperacao-judiciaria/cooperacao-judiciaria.module').then(m => m.CooperacaoJudiciariaModule)
    },
    {
        path: Path.PLANTAO.caminho,
        loadChildren: () => import('./../plantao-judiciario/plantao-judiciario.module').then(m => m.PlantaoJudiciarioModule)
    },
    {
        path: Path.JFRN_SUSTENTAVEL.caminho,
        loadChildren: () => import('./../jfrn-sustentavel/jfrn-sustentavel.module').then(m => m.JFSustentavelModule)
    },
    {
        path: Path.SEI.caminho,
        loadChildren: () => import('./../sei/sei.module').then(m => m.SeiModule)
    },
    {
        path: Path.JF_MEDIA.caminho,
        loadChildren: () => import('./../jf-media/jf-media.module').then(m => m.JfMediaModule)
    },
    {
        path: Path.CERTIDAO_NEGATIVA.caminho,
        loadChildren: () => import('./../certidao-negativa/certidao-negativa.module').then(m => m.CertidaoNegativaModule)
    },
    {
        path: Path.QUINTA_JURIDICA.caminho,
        loadChildren: () => import('./../quinta-juridica/quinta-juridica.module').then(m => m.QuintaJuridicaModule)
    }

];

@NgModule({
    declarations: [PaginaPrincipalComponent, ChatComponent],
    imports: [
        RouterModule.forChild(routes),
        RouterModule,
        CommonModule,
        SharedModule,
        TooltipModule,
        FormsModule
    ],
    exports: [PaginaPrincipalComponent, ChatComponent],
})

export class PaginaPrincipalModule { }
